var gridItemPropsToCss = function gridItemPropsToCss(_ref) {
  var alignSelf = _ref.alignSelf,
    area = _ref.area,
    columnEnd = _ref.columnEnd,
    columnStart = _ref.columnStart,
    justifySelf = _ref.justifySelf,
    rowEnd = _ref.rowEnd,
    rowStart = _ref.rowStart;
  return "\n  ".concat(alignSelf ? "align-self: ".concat(alignSelf, ";") : '', "\n  ").concat(area ? "grid-area: ".concat(area, ";") : '', "\n  ").concat(columnEnd ? "grid-column-end: ".concat(columnEnd, ";") : '', "\n  ").concat(columnStart ? "grid-column-start: ".concat(columnStart, ";") : '', "\n  ").concat(rowEnd ? "grid-row-end: ".concat(rowEnd, ";") : '', "\n  ").concat(rowStart ? "grid-row-start: ".concat(rowStart, ";") : '', "\n  ").concat(justifySelf ? "justify-self: ".concat(justifySelf, ";") : '', "\n");
};
export default gridItemPropsToCss;